import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { MultiSelect } from "primereact/multiselect";
import { useState } from "react";

export default function Tableview ({tableData, totalRecords, first, rows, loading, editfrom, handledelete, setTempFilterValues, tempFilterValues, cusfilter, onPage}) {

     const [filterOptions,setFilterOptions] = useState({});
    
        const Sno = (rowIndex) => {
            console.log(first  , rowIndex);
            return (
                <>
                  <div className="flex gap-3">
                    {first+rowIndex+1}
                  </div>
                </>
            );
        };
    
        const columns = [
            { header: 'S.No', body: Sno },
            { field: 'Test_name', header: 'Test Name', filter: true },
            { field: 'Status', header: 'Status', filter: true },
           
        ];
    
        const handleApplyFilters = (key) => {
            cusfilter(key, tempFilterValues[key]);
            onPage({ first: 0, rows: rows });
        };
    
        const handleClearFilters = (key) => {
            setTempFilterValues(prev => ({ ...prev, [key]: null }));
            cusfilter(key, null);
            onPage({ first: 0, rows: rows });
        };
    
        const getOption = async (key)=>{
            var filterOptions = await getFilterOptions(key);
            setFilterOptions(filterOptions)
            console.log(filterOptions)
        }

        const actionbotton = (rowData) => {
            return (
            <div className="flex gap-2">
                <button onClick={() => editfrom(rowData)}>
                <i className="text-xl text-green-500 cursor-pointer fi fi-sr-pen-circle"></i>
                </button>
                <button onClick={() => handledelete(rowData?._id)}>
                <i className="text-xl text-red-500 cursor-pointer fi fi-sr-trash"></i>
                </button>
            </div>
            );
        };
    
        const renderColumnFilter = (key) => (
            <div onClick={()=>getOption(key)}>
                <MultiSelect filter value={tempFilterValues[key]} options={filterOptions?.[key]} className="p-column-filter" virtualScrollerOptions={{ itemSize: 43 }} maxSelectedLabels={1}
                    onChange={(e) => setTempFilterValues(prev => ({ ...prev, [key]: e.value }))} placeholder={`Select ${key?.charAt(0).toUpperCase() + key?.slice(1)}`} panelFooterTemplate={
                    <div className="flex justify-between p-2 mt-2">
                        <button label="Clear" onClick={() => handleClearFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                            Clear
                        </button>
                        <button label="Apply" onClick={() => handleApplyFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                            Apply
                        </button>
                    </div>
                } />
            </div>
        );
    
    return (
        <>
            <DataTable value={tableData} loading={loading} totalRecords={totalRecords} scrollable scrollHeight="calc(100vh - 320px)" className="!text-sm border border-gray-200 rounded">
                <Column header="Action" body={actionbotton} />
                {columns.map((col, i) => (
                    col.header === 'S.No' ?(
                        <Column key={i} field={col.field} header={col.header} body={(rowData,{rowIndex})=>Sno(rowIndex)} headerClassName="text-gray-700 bg-gray-50" />
                    ):
                    col.formattype === 'array' ? (
                        <Column key={i} header={col.header} field={col.field} style={{ minWidth: col.width }} body={array} filter={col.filter} filterElement={renderColumnFilter(col.field)}
                            showFilterMenuOptions={false} showFilterMatchModes={false} showApplyButton={false} showClearButton={false} sortable headerClassName="text-gray-700 bg-gray-50"/>
                    ) : (
                        <Column key={i} field={col.field} header={col.header} body={col.body} filter={col.filter} filterElement={renderColumnFilter(col.field)}
                            showFilterMenuOptions={false} showFilterMatchModes={false} showApplyButton={false} showClearButton={false} sortable headerClassName="text-gray-700 bg-gray-50" />
                    )
                ))}
            </DataTable>
        </>
    )
}